import {Grid} from "@mui/material";
import React from "react";
import {useTranslation} from "react-i18next";
import {CardContainerTitle} from "../../../../components/CardContainerTitle";
import {StadiumEntrance} from "./StadiumEntrance";

export function StadiumEntrances() {
	const {t} = useTranslation();

	return (
		<Grid item xs={12}>
			<CardContainerTitle title={t("club.stadium.entrances")}/>
			<Grid container spacing={1}>
				<StadiumEntrance name={"1"} location={t("club.stadium.northwest")}
				                 description={t("club.stadium.entryToMarcosTavares")}/>
				<StadiumEntrance name={"2"} location={t("club.stadium.southwest")}
				                 description={t("club.stadium.entryToMarcosTavares")}/>
				<StadiumEntrance name={"3"} location={t("club.stadium.south")}
				                 description={t("club.stadium.entryToSouthTribune")}/>
				<StadiumEntrance name={"4"} location={t("club.stadium.south")}
				                 description={t("club.stadium.entryToSouthTribune")}/>
				<StadiumEntrance name={"5"} location={t("club.stadium.southeast")}
				                 description={t("club.stadium.entryToEastTribune")}/>
				<StadiumEntrance name={"6"} location={t("club.stadium.northeast")}
				                 description={t("club.stadium.entryToEastTribune")}/>
				<StadiumEntrance name={"7"} location={t("club.stadium.north")}
				                 description={t("club.stadium.entryToNorthTribune")}/>
				<StadiumEntrance name={"8"} location={t("club.stadium.north")}
				                 description={t("club.stadium.entryToNorthTribune")}/>
				<StadiumEntrance name={"V1"} location={t("club.stadium.northwest")}
				                 description={t("club.stadium.entryToMarcosTavaresVip")}/>
				<StadiumEntrance name={"V2"} location={t("club.stadium.southwest")}
				                 description={t("club.stadium.entryToMarcosTavaresVip")}/>
			</Grid>
		</Grid>
	)
}
